import React, {Component} from 'react';
import API from "../../services/API";
import Toast from "../Common/Toast";
import Actionbar from "../Common/Actionbar";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faAngleLeft,
     faWallet
} from "@fortawesome/free-solid-svg-icons";
import Navbar from "../Common/Navbar";
import Loading from "../Common/Loading";
const currencyFormat = Intl.NumberFormat('en-US');

class OwnersList extends Component {
    state = {
        owners : [],
        request: [],
        present_today : 0,
        present_tomorrow : 0,
        isLoaded: false,
        driverName: ''
    }
    onSearchDriver = (event) => {
        this.setState({driverName : event.target.value})
        if(event.target.value.length > 2) {
            const request = {
                search_key : event.target.value
            }
            API.transportUsers(request)
                .then((response) => {
                    this.setState({owners : response.results.owners , request : response.results.request})

                })
                .catch((error) => {
                    //   toast.error(error.response.data.user_message);
                });
        }
        if(event.target.value.length  < 1) {
            const request = {
                expert_owners : true,

            }
            API.transportUsers(request)
                .then((response) => {
                    this.setState({owners : response.results.owners , request : response.results.request})

                })
                .catch((error) => {
                    //   toast.error(error.response.data.user_message);
                });
        }

    }

    render() {
        return (
            <React.Fragment>
                {!this.state.isLoaded ? <Loading/> :''}
                <Toast/>
                <Actionbar noBack={0} title='لیست  کاربران'/>
                <section className="container p-4 rtl my-5">
                    <div className="row my-3">
                        <div className="col-12">
                            <div className="form-floating super-small-2">
                                <input type="text" className="form-control height-40" id="floatingInput"
                                       placeholder="جستجو  راننده"
                                       onChange={this.onSearchDriver}
                                       value={this.state.driverName}
                                />
                                <label htmlFor="floatingInput">جستجو شخص با نام خانوادگی</label>
                            </div>

                        </div>


                    </div>
                    {
                        this.state.owners.map(user => {

                            return (
                                <div className='row driver-row' key={user.id}
                                     onClick={() => {this.props.history.push('/users-wallet/' + user.id) }}
                                >
                                    <div className="col-2">
                                        <img src={user.avatar} alt="avatar" className='w-100 rounded-more'/>
                                    </div>
                                    <div className="col-8">
                                        {user.full_name}
                                        <div className='super-small-2 mt-2 text-secondary'>
                                            <FontAwesomeIcon icon={faWallet}/>
                                            &nbsp;
                                            {currencyFormat.format( user.balance)}
                                            &nbsp;
                                            ریال
                                        </div>
                                    </div>
                                    <div className='col-2 pt-2 text-left'>

                                            <FontAwesomeIcon icon={faAngleLeft} className='text-success '/>

                                    </div>

                                </div>

                            )

                        })
                    }
                </section>
                <Navbar  />
            </React.Fragment>
        );
    }
    componentDidMount() {
        const request = {

        }
        API.transportUsers(request)
            .then((response) => {
                this.setState({owners : response.results.owners , request : response.results.request})
                this.setState({ isLoaded : true})
                setTimeout (() => {
                    window.scrollTo({top: 0, behavior: 'smooth'});
                },400)

            })
            .catch((error) => {
                //   toast.error(error.response.data.user_message);
            });
    }
}

export default OwnersList;